export default "__VITE_ASSET__CkcQxpz3__"